import { handleActions } from 'redux-actions'
import {priv} from '../actions/shared-dataset'
import {datasetSelector} from '../selectors/shared-dataset'

export default handleActions({
  [priv.datasets_data_ready]: (state, action) => {
    let old_dataset = datasetSelector(state)

    let {dataset} = action.payload

    if (! dataset || ! old_dataset || dataset.public_guid !== old_dataset.public_guid || dataset.timestamp !== old_dataset.timestamp)
    {
      return {
        dataset
      }
    }
    else 
    {
      return state
    }
  }
}, {dataset: null})


// WEBPACK FOOTER //
// ./src/reducers/shared-dataset.js